import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LayoutService } from '../../../core/services/layout.service';

@Component({
  selector: 'tt-consignment-delivery',
  templateUrl: './consignment-delivery.component.html',
  styleUrls: ['./consignment-delivery.component.css']
})
export class ConsignmentDeliveryComponent implements OnInit {
    public selectedBgConsignmentDelivery: string = 'active';

    public setting?: Setting;

    public deliveryMethodNo: string | any = '';

    public selectListDeliveryMethods: Item[] = [];

    public itemsListConsignmentDeliveries: Item[] = [];

    public itemsListConsignmentDeliveriesActive: Item[] = [];

    public itemsListConsignmentDeliveriesDelivered: Item[] = [];

    public tabletMediaQuery: MediaQueryList;

    constructor(layout: LayoutService, private datatask: DataTaskService) {
        this.tabletMediaQuery = layout.getMediaQueries().tablet;
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1997))[0];

        if (!!this.setting) {
            if (this.setting.active_deliverymethod_no !== '0') {
                this.deliveryMethodNo = this.setting.active_deliverymethod_no;
            } else {
                this.setting.active_deliverymethod_no = '0';
            }
        }
    }

    private async loadDeliveryMethods() {
        this.selectListDeliveryMethods = await this.datatask.Post(1978);
    }

    private async loadConsignmentDeliveries() {
        if (!this.deliveryMethodNo) return;

        if (this.deliveryMethodNo !== '0') {
            if (this.tabletMediaQuery.matches) {
                this.itemsListConsignmentDeliveriesActive = await this.datatask.Post(1976, {
                    deliverymethod_no: this.deliveryMethodNo,
                    list_type: 'active'
                });

                this.itemsListConsignmentDeliveriesDelivered = await this.datatask.Post(1976, {
                    deliverymethod_no: this.deliveryMethodNo,
                    list_type: 'delivered'
                });
            } else {
                this.itemsListConsignmentDeliveries = await this.datatask.Post(1976, {
                    deliverymethod_no: this.deliveryMethodNo,
                    list_type: this.selectedBgConsignmentDelivery
                });
            }
        }
    }

    public onTabChanged() {
        this.loadConsignmentDeliveries();
    }

    public onChanged(_: string | any, id: string) {
        if (!this.deliveryMethodNo) return;

        switch (id) {
            case 'deliveryMethodNo':
                this.loadConsignmentDeliveries();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadDeliveryMethods();
        
        if (!this.tabletMediaQuery.matches) {
            if (this.selectListDeliveryMethods.length > 0) this.loadConsignmentDeliveries();
        } else {
            this.loadConsignmentDeliveries();
        }
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    cd_deliverymethod_no: string;
    active_deliverymethod_no: string;
}
